"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('setup.scripts.packages', function () {
    namespace_1.default.utils.extend(this, new namespace_1.default.setup.scripts());
    this.getUrl = function (type, name) {
        return namespace_1.default.params.paths[type].script + '/apa.' + name + '.js?cb=' + namespace_1.default.params.cachebreaker;
    };
    /*
        Complex function to determine which packages has to be loaded and returns an array afterwards.

        In case:	wahlen.actual.ranking, wahlen.actual.results
        It returns: [ wahlen.actual ]

        In case:	sport.ranking.tables, wahlen.actual.results
        It returns: [ sport.ranking.tables, wahlen.actual.results ]

        In case:	sport.ranking.tables, wahlen.actual.results, wahlen.history
        It returns: [ sport.ranking.tables, wahlen ]

    */
    this.getPackages = function (items) {
        var fileArray = [];
        items.forEach(function (item) {
            fileArray.push(item.codebase);
        });
        fileArray = fileArray.sort(function (a, b) {
            return a.length - b.length;
        });
        var done = false;
        var filesToLoad = [];
        do {
            for (var i = 0; i < fileArray.length; i++) {
                var file = fileArray[i];
                var add = true;
                for (var j = 0; j < filesToLoad.length; j++) {
                    var existingFile = filesToLoad[j];
                    if (file.indexOf(existingFile) > -1) { // tFile is a subpackage of an existing file
                        add = false;
                    }
                    else { // tFile and existingFile have a common parent-package
                        var fileArr = file.split('.');
                        var existingArr = existingFile.split('.');
                        var tMatch = true;
                        var tFrom = -1;
                        for (var k = fileArr.length - 1; k >= 0; k--) {
                            var fileSpace = fileArr[k];
                            var existingSpace = existingArr[k];
                            if (existingSpace !== undefined) {
                                if (fileSpace == existingSpace) {
                                    tMatch = true;
                                    if (tFrom < k)
                                        tFrom = k;
                                }
                                else {
                                    tFrom = -1;
                                    tMatch = false;
                                }
                            }
                        }
                        if (tMatch && tFrom >= 0) {
                            add = false;
                            filesToLoad[j] = fileArr.slice(0, tFrom + 1).join('.');
                        }
                    }
                }
                if (add)
                    filesToLoad.push(file);
            }
            /*
                we have to check whether there were changes since the last run = the last loop has not affected changes
                    if not, we can set done to true and exit
            */
            if (this.arrayEquals(filesToLoad.sort(), fileArray.sort())) {
                done = true;
            }
            else {
                fileArray = filesToLoad;
                filesToLoad = [];
            }
        } while (!done);
        return filesToLoad;
    };
    this.arrayEquals = function (a, b) {
        return Array.isArray(a)
            && Array.isArray(b)
            && a.length === b.length
            && a.every(function (val, index) { return val === b[index]; });
    };
});
